export default "__VITE_ASSET__CvlabD4r__"